module.exports = __webpack_public_path__ + "img/button.0fc26974.png";